const AccomImg = require('../../../../www/images/accommodation.svg');
const ColoredAccomImg = require('../../../../www/images/accommodation-with-color.svg');
const NonAccomImg = require('../../../../www/images/non-accommodation.svg');
const ColoredNonAccomImg = require('../../../../www/images/non-accommodation-with-color.svg');
const BuyerImg = require('../../../../www/images/buyer.svg');
const ColoredBuyerImg = require('../../../../www/images/buyer-with-color.svg');
const DMOImg = require('../../../../www/images/dmo.svg');
const ColoredDMOImg = require('../../../../www/images/dmo-with-color.svg');
const OtherImg = require('../../../../www/images/other.svg');
const ColoredOtherImg = require('../../../../www/images/other-with-color.svg');
import {
  accomCompanyTypesFields,
  nonAccomCompanyTypesFields,
  basicBuyerTypes,
  DMOtypes,
  otherBuyersTypes,
} from '../../../utils/select-fields';

export const compTypeInfo = [
  {
    icon: AccomImg,
    coloredIcon: ColoredAccomImg,
    companyType: 'Accommodation',
    desc: "We're an accommodation supplier.",
    checkBoxItems: accomCompanyTypesFields,
  },
  {
    icon: NonAccomImg,
    coloredIcon: ColoredNonAccomImg,
    companyType: 'Non-Accommodation',
    desc: "We're a non-accommodation supplier.",
    checkBoxItems: nonAccomCompanyTypesFields,
  },
  {
    icon: BuyerImg,
    coloredIcon: ColoredBuyerImg,
    companyType: 'buyer',
    desc: "We're an agent/buyer.",
    checkBoxItems: basicBuyerTypes,
  },
  {
    icon: DMOImg,
    coloredIcon: ColoredDMOImg,
    companyType: 'dmo',
    desc: "We're a destination marketing organization.",
    checkBoxItems: DMOtypes,
  },
  {
    icon: OtherImg,
    coloredIcon: ColoredOtherImg,
    companyType: 'other',
    desc: 'We serve the tourism industry.',
    checkBoxItems: otherBuyersTypes,
  },
];



// WEBPACK FOOTER //
// ./src/app/components/signup/select-company-type/company-type-text.jsx